module.exports = __webpack_public_path__ + "static/media/zainab.42cd245f.png";